// =============================================================================
// Odświeżanie co N ms, ale TYLKO przy widocznej karcie przeglądarki (UD-12a).
//
// Lista dokumentów pyta bazę co 30 s (rytm karty agenta, `ZEGAR_MS`). Karta
// schowana w tle nie ma komu pokazać odpowiedzi, więc tik wtedy nie pyta; po
// powrocie na kartę odświeżenie rusza OD RAZU, a nie po kolejnych 30 s — inaczej
// człowiek patrzyłby przez pół minuty na dane sprzed godziny.
//
// Funkcja jest czytana przez ref, więc nowa funkcja przy każdym renderze nie
// przestawia zegara (interwał zakłada się raz na zmianę `ms`/`wlaczone`).
// =============================================================================

import { useEffect, useRef } from 'react';

export function useOdswiezanieWidocznejKarty(fn: () => void, ms: number, wlaczone = true): void {
  const ref = useRef(fn);
  ref.current = fn;

  useEffect(() => {
    if (!wlaczone) return;
    const gdyWidoczna = () => {
      if (document.visibilityState === 'visible') ref.current();
    };
    const id = setInterval(gdyWidoczna, ms);
    document.addEventListener('visibilitychange', gdyWidoczna);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', gdyWidoczna);
    };
  }, [ms, wlaczone]);
}
